import type { Call } from "../types";
import { formatPhoneNumber } from "./formatPhoneNumber";

export function mapCallParticipantData(
	data: Record<string, unknown>,
): Pick<
	Call,
	| "caller"
	| "agent"
	| "inboundNumber"
	| "source"
	| "from"
	| "destinationNumber"
	| "operatorName"
	| "direction"
	| "isOutbound"
	| "callType"
	| "operatorPhoneNumber"
> {
	const callerName =
		typeof data.callerName === "string" && data.callerName.trim()
			? data.callerName.trim()
			: "Unknown";

	return {
		caller: {
			name: callerName,
			phone: formatPhoneNumber(data.from || ""),
			email:
				typeof data.callerEmail === "string" ? data.callerEmail : undefined,
		},
		agent: typeof data.agentName === "string" ? data.agentName : "agent1",
		inboundNumber: formatPhoneNumber(data.inboundNumber || data.to || ""),
		source: typeof data.source === "string" ? data.source : null,
		from: typeof data.from === "string" ? data.from : null,
		destinationNumber:
			typeof data.destinationNumber === "string"
				? data.destinationNumber
				: null,
		operatorName:
			typeof data.operatorName === "string" ? data.operatorName : null,
		direction:
			data.direction === "inbound" || data.direction === "outbound"
				? data.direction
				: null,
		isOutbound: data.isOutbound === true,
		callType:
			data.callType === "human" || data.callType === "ai"
				? data.callType
				: null,
		operatorPhoneNumber:
			typeof data.operatorPhoneNumber === "string"
				? data.operatorPhoneNumber
				: null,
	};
}
